import ListAltIcon from '@material-ui/icons/ListAlt';

import ModelList from './ModelList';
import ModelCreate from "./ModelCreate";

const resource = {
    list: ModelList,
    create: ModelCreate,
    icon: ListAltIcon,
    options: {
        label: 'resources.admin/cob-manufacturers.name'
    }
};

export default resource;
